import React from "react"
import {Trans, useTranslation} from "react-i18next"

import {ConfirmModal} from "../../../components/Modal.tsx"
import {useDeactivateUserMutation} from "../../../queries/saasUserManagement.ts"
import requestError from "../../../services/requestError.tsx"
import {getFullName} from "../../../utils"
import {commonTransComponents} from "../../../utils/i18n.tsx"
import {DeactivateUserContext} from "../context.ts"

export const DeactivateUserModal: React.FC = () => {
  const {t} = useTranslation()

  const context = DeactivateUserContext.useContext()
  const user = context.value

  const deactivateUserMutation = useDeactivateUserMutation()

  const handleDeactivate = React.useCallback(async () => {
    try {
      if (user?.id === undefined) {
        return false
      }

      await deactivateUserMutation.mutateAsync({id: user.id})
    } catch (e) {
      requestError(e)
      return false
    }
  }, [deactivateUserMutation, user?.id])

  return (
    <ConfirmModal
      onConfirm={handleDeactivate}
      isOpen={!!user}
      onClose={() => context.setValue(null)}
      title={t("SaaSUserManagement_Table_Deactivate_Title")}
      variant={"error"}
      confirmButtonText={t("SaaSUserManagement_Table_Deactivate_ConfirmButton")}
    >
      <Trans
        i18nKey={"SaaSUserManagement_Table_Deactivate_Text"}
        values={{name: getFullName(user, user?.email ?? t("SaaSUserManagement_Table_Deactivate_NamePlaceholder"))}}
        components={commonTransComponents}
      />
    </ConfirmModal>
  )
}
